import { Helmet } from 'react-helmet-async';
const SEO = ({ 
  title, 
  description = "Kabil Mbarki — CEO & Founder of KaTEK | Computer Engineer specializing in Robotics, IoT, AI, Embedded Systems, and Full-Stack Development. Explore innovative projects and professional experience.", 
  keywords = "Kabil Mbarki, KaTEK, CEO, Founder, Computer Engineer, Robotics Engineer, IoT Engineer, AI, Artificial Intelligence, Machine Learning, Embedded Systems Engineer, Internet of Things, Flutter Developer, Mobile Development, ROS2, ESP32, Arduino, Raspberry Pi, C/C++, Dart, Firebase, Computer Vision, Deep Learning, Edge AI, PCB Design, Path Planning, Robot Programming, Autonomous Systems, Full Stack Developer, Python, Node.js", 
  image = "https://mbarkikabilportfolio.netlify.app/og-image.jpg",
  type = 'website',
  article = null
}) => {
  // Get current path from window.location if available
  const isBrowser = typeof window !== 'undefined';
  const pathname = isBrowser ? window.location.pathname : '';
  
  const siteUrl = 'https://mbarkikabilportfolio.netlify.app';
  const siteName = 'Kabil Mbarki - CEO & Founder of KaTEK';
  const defaultImage = `${siteUrl}/og-image.jpg`;
  const currentUrl = `${siteUrl}${pathname}`;
  const twitterHandle = '@kabilmbarki';

  const seo = {
    title: title ? `${title} | ${siteName}` : siteName,
    description,
    url: currentUrl,
    image: image || defaultImage,
    type,
    keywords,
    author: 'Kabil Mbarki',
    twitter: twitterHandle,
    publishedTime: article?.publishedTime || '',
    modifiedTime: article?.modifiedTime || '',
    section: article?.section || 'Technology',
    tags: article?.tags || ['KaTEK', 'CEO', 'Founder', 'Computer Engineering', 'Robotics', 'AI', 'Artificial Intelligence', 'Machine Learning', 'Embedded Systems', 'IoT', 'Internet of Things', 'Flutter', 'Mobile Development', 'ROS2', 'ESP32', 'Arduino', 'Raspberry Pi', 'C/C++', 'Dart', 'Firebase', 'Computer Vision', 'Deep Learning', 'Edge AI', 'PCB Design', 'Path Planning', 'Autonomous Systems', 'Python', 'Node.js']
  };

  // Generate JSON-LD structured data
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    'name': 'Kabil Mbarki',
    'url': siteUrl,
    'sameAs': [
      'https://github.com/kabilmbarki',
      'https://www.linkedin.com/in/kabil-mbarki-581b56250/',
      'https://x.com/Kabil_Mbarki'
    ],
    'jobTitle': 'CEO & Founder of KaTEK | Robotics, IoT & AI Systems Engineer',
    'worksFor': {
      '@type': 'Organization',
      'name': 'KaTEK'
    },
    'description': seo.description,
    'image': seo.image
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seo.title}</title>
      <meta name="title" content={seo.title} />
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <meta name="author" content={seo.author} />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={seo.type} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:creator" content={seo.twitter} />
      
      {/* Article specific meta tags */}
      {article && (
        <>
          <meta property="article:published_time" content={seo.publishedTime} />
          <meta property="article:modified_time" content={seo.modifiedTime} />
          <meta property="article:section" content={seo.section} />
          {seo.tags.map((tag, index) => (
            <meta property="article:tag" content={tag} key={index} />
          ))}
        </>
      )}
      
      {/* Canonical URL */}
      <link rel="canonical" href={seo.url} />
      
      {/* Favicon */}
      <link rel="icon" type="image/png" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
      
      {/* JSON-LD structured data */}
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};

export default SEO;
